var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e58b6ae1-de60-4bad-a020-58cedc290202",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-8e66e4ab-0c1a-4e11-a700-41a7bea75250 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-8e66e4ab-0c1a-4e11-a700-41a7bea75250",
    d: "M8.5,17.48l7.5,4.22,6.73-3.77v1.5l-6.73,3.8-7.12-4.05-.38.21v.52l7.5,4.22,7.5-4.22v-2.93l-.35-.21-7.15,4.05-6.7-3.84v-1.5l6.7,3.77,7.5-4.22v-2.9l-.35-.21-7.15,4.05-6.35-3.59,6.35-3.59,5.27,2.96.45-.28v-.38l-5.72-3.24-7.5,4.26v.49l7.5,4.22,6.73-3.77v1.53l-6.73,3.8-7.12-4.05-.38.21v2.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/Databricks.4e4e3f6e917a12ae4fe2cc320a9dfc02.svg";
export { ForwardRef as ReactComponent };